// element.js 全文内容如下，按自己需要引入就好了
import Vue from 'vue'
import {
    Image,
    Upload,
    DatePicker,
    Scrollbar,
    Popover,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Popconfirm,
    Button,
    Form,
    Radio,
    FormItem,
    Input,
    Message,
    Container,
    Header,
    Aside,
    Main,
    Menu,
    Submenu,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    Card,
    Row,
    Col,
    Table,
    TableColumn,
    Switch,
    Tooltip,
    Pagination,
    Dialog,
    MessageBox,
    Tag,
    Tree,
    Select,
    Option,
    Cascader,
    Alert,
    Tabs,
    TabPane,
	Checkbox,
	Steps,
	Step,
	RadioGroup,
	Progress,
	CheckboxGroup,
	InputNumber,
	Drawer,
	MenuItemGroup
} from 'element-ui'
Vue.use(Drawer)
Vue.use(InputNumber)
Vue.use(CheckboxGroup)
Vue.use(Progress)
Vue.use(RadioGroup)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Checkbox)
Vue.use(Image)
Vue.use(Popover)
Vue.use(Scrollbar)
Vue.use(Upload)
Vue.use(DatePicker)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popconfirm)
Vue.use(Button)
Vue.use(Form)
Vue.use(Radio)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(Cascader)
Vue.use(Alert)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(MenuItemGroup)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
